import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CategoryFiltersGql from '@/store/graphql/cms/queries/CategoryFilters.gql';
import CreateCategoryFilterGql from '@/store/graphql/cms/mutations/CreateCategoryFilter.gql';
// import UpdateCategoryFilterGql from '@/store/graphql/cms/mutations/UpdateCategoryFilter.gql';
import DeleteCategoryFilterGql from '@/store/graphql/cms/mutations/DeleteCategoryFilter.gql';

export default {
    fetchList: (cmsID = null, category_id = null, category_key = null)  =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);
            if (category_id) variables.category_id = parseInt(category_id);
            if (category_key) variables.category_key = category_key;
            apolloClient
                .query({
                    query: CategoryFiltersGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_CategoryFilters))
                .catch(err => reject(err));
        }),
    create: categoryFilter => {
        if (categoryFilter === undefined) throw new Error('required argument is missing');

        categoryFilter = _.removeDeepByKey(categoryFilter, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCategoryFilterGql,
                    variables: { categoryFilter }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CreateCategoryFilter);
                })
                .catch(err => reject(err));
        });
    },
    delete: categoryFilter => {
        let filterID;
        if (categoryFilter === undefined) throw new Error('required argument is missing');
        if (categoryFilter && categoryFilter.id) {
            filterID = parseInt(_.cloneDeep(categoryFilter.id));
        }else throw new Error('required argument is missing');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCategoryFilterGql,
                    variables: { id: filterID }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_DeleteCategoryFilter);
                })
                .catch(err => reject(err));
        });
    },
    // eslint-disable-next-line
    // updateCategoryFilters: (cmsID = null, filters = null) =>
    //     new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 // eslint-disable-next-line
    //                 mutation: UpdateCategoryFilterGql,
    //                 variables: { filters }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CP_UpdateCategoryFilters);
    //             })
    //             .catch(err => reject(err));
    //     })
};
